type IconLinkProps = {
	target: string
	children: React.ReactNode
}

export default function IconLink({ target, children }: IconLinkProps) {
	return (
		<a
			href={target}
			className="hover:cursor-pointer"
			target="_blank"
			rel="noopener noreferrer"
		>
			{children}
		</a>
	)
}
